import Card from "@material-ui/core/Card";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Link as LinkRouter } from "react-router-dom";

import { CameraHealth } from "@/api/streamMetadata";

import HealthDot from "../HealthDot/HealthDot";
import Thumbnail from "./Thumbnail";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            border: "3px solid transparent",
            borderRadius: 8,
        },
        root: {
            position: "relative",
            width: "100%",
            height: 0,
            paddingTop: "28.125%",
            paddingBottom: "28.125%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
        },
        imageLoaded: {
            backgroundColor: theme.palette.primary.main,
        },
        isActiveUnitNameDiv: {
            position: "absolute",
            bottom: 0,
            width: "100%",
            padding: "0.25em",
            backgroundColor: theme.palette.primary.light,
            opacity: 0.8,
        },
        unitNameDiv: {
            marginLeft: "0.5em",
            fontWeight: "bold",
            color: theme.palette.primary.contrastText,
            display: "inline",
        },
        healthDot: {
            marginLeft: "3px",
            position: "relative",
            top: "3px",
            display: "inline",
        },
        subBorder: {
            border: "2px solid transparent",
            borderRadius: 4,
        },
        active: {
            border: `2px solid ${theme.palette.secondary.main}`,
        },
    }),
);

interface CameraProps {
    cameraId: number;
    unitName: string;
    imageUrl: string;
    active?: boolean;
    health: CameraHealth;
}

export const ImgMediaCard: React.FC<CameraProps> = ({ cameraId, unitName, health, imageUrl, active }) => {
    const muiClasses = useStyles();

    return (
        <div data-testid="imgMediaCard" className={clsx([muiClasses.container, { [muiClasses.active]: active }])}>
            <div className={clsx([muiClasses.subBorder])}>
                <LinkRouter to={`/camera/${cameraId}/stream`}>
                    <Card className={clsx([muiClasses.root, muiClasses.imageLoaded])}>
                        {imageUrl &&
                            <Thumbnail
                                unitName={unitName}
                                imageUrl={imageUrl}
                            />
                        }
                        <div className={muiClasses.isActiveUnitNameDiv}>
                            <HealthDot health={health} classes={muiClasses.healthDot} size="1rem"></HealthDot>
                            <span className={muiClasses.unitNameDiv} color="primary">
                                {unitName}
                            </span>
                        </div>
                    </Card>
                </LinkRouter>
            </div>
        </div >
    );
};

export default ImgMediaCard;
